import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import {
  ComponentBase,
  SharedService,
  VerifyMobileNumberType,
} from 'src/app/core';
import { SalesChatService } from 'src/app/core';

@Component({
  selector: 'app-verify-identity',
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.scss'],
})
export class VerifyIdentityComponent extends ComponentBase implements OnInit {
  /** When true, uses inputs from parent instead of route params */
  @Input() inlineMode: boolean = false;

  @Input() showPhoneNumber: boolean = false;

  /** Phone number or user identifier from parent in inline mode */
  @Input() inlineUser?: string;

  /** Registration cycle log ID from parent in inline mode */
  @Input() inlineRegistrationCycleLogId?: string;

  /** When false, verify method cards are disabled until parent countdown ends */
  @Input() canChangeVerifyType: boolean = true;

  /** Emitted when user selects a new verify method to notify parent of verifyType change */
  @Output() backToVerification = new EventEmitter<{
    verifyType: VerifyMobileNumberType;
  }>();

  /** Emitted when closing the sidebar (if applicable) */
  @Output() closeSidebar = new EventEmitter<void>();

  /** Form instance */
  form!: FormGroup;

  /** Reference to verify type enum (SMS or Whatsapp) */
  verifyMobileNumberType = VerifyMobileNumberType;

  /** Verification query data (user, verifyType, RegistrationCycleLogId) */
  queryParamsData: {
    user: string | null;
    verifyType: VerifyMobileNumberType | null;
    RegistrationCycleLogId: string | null;
  } = {
    user: null,
    verifyType: null,
    RegistrationCycleLogId: null,
  };

  /** Returns masked phone number (only last four digits visible) */
  get maskedPhone(): string {
    const phone = this.queryParamsData.user ?? this.inlineUser ?? '';
    if (!phone) return '';

    const lastFour = phone.length > 4 ? phone.slice(-4) : phone;
    return `*******${lastFour}`;
  }

  /** Creates the component and injects services */
  constructor(
    private salesChatService: SalesChatService,
    public readonly sharedService: SharedService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.salesChatService.chatScript();
    this.queryParamsData.user = this.inlineUser ?? null;
    this.queryParamsData.RegistrationCycleLogId = this.inlineRegistrationCycleLogId ?? null;
  }

  /** Called when user selects a verify method (SMS or Whatsapp); notifies parent */
  onSelectVerifyType(verifyType: VerifyMobileNumberType): void {
    this.queryParamsData.verifyType = verifyType;
    this.backToVerification.emit({ verifyType });
  }
}
